<template>
  <div class="landing-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="" style="text-align: center">
            <img style="width: 35%;margin-top: 50px" src="../../static/images/logo.png">
          </div>
          <div class="middle">
            <img src="../../static/images/login_pic1.png">
          </div>
          <div class="login-tip">
            <span>{{ $t('loginTips') }}</span>
          </div>
          <div class="login-overlay">
            <div class="input-div">
              <div class="input-item mt20"
                   style="background: rgba(255, 255, 255, 0.85);">
                <div class="input-item2">
                  <input ref="mobileInput" class="input" style="color: black" v-model="mobile" type="tel"
                         maxlength="15"
                         inputmode="numeric"
                         pattern="[0-9]*" @input="handleNumberInput">
                </div>
              </div>
            </div>
            <div class="ac mt30 por">
              <div class="login-list" >
                <div class="drown-li"  @click="goLogin()">
                  <div class="disflex day por day-en">
                    <div class="btn-text">{{ $t('Login') }}</div>
                  </div>
                </div>

              </div>
            </div>
            <div class="ac por esim-row">
              <div class="esim-text">
                <span>{{ $t('need_esim_prefix') }}</span>
                <span class="esim-link" @click="goBuyESim">{{ $t('get_esim') }}</span>
              </div>
            </div>
          </div>
<!--          <div class="ac otp-b disflex por login-footer">
            <div class="icon icon2 login_help" @click="getChange('faq')">{{ $t('FAQs') }}</div>
          </div>-->
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import Dialog from "../components/dialog.vue";
import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  components: {
    Dialog,

  },
  data() {
    return {
      isEN: "bur",
      list: [],
      mobile: '',
      type: '',
      channel: '',
    }
  },
  computed: {

  },
  created() {
    if (localStorage.getItem('lang')) {
      this.isEN = localStorage.getItem('lang');
    }
    if (this.$route.query.msidn) {
      this.mobile = this.aesEcbDecrypt(this.$route.query.msidn);
    }
    if (this.$route.query.channel) {
      this.channel = this.$route.query.channel;
    }
    // this.checkLocalToken();
    this.sendReport();
  },
  methods: {
    checkLocalToken() {
      const token = localStorage.getItem('token') || '';
      if (!token) {
        return;
      }
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/user/info', {}, r => {
        that.$parent.loadModal(false);
        if(r.code==1){
          window.location.href = '/app';
        }
      })
    },
    handleNumberInput(event) {
      this.mobile = event.target.value.replace(/[^0-9]/g, '');
    },
    getNormalizedMobile() {
      const inputValue = this.$refs.mobileInput && this.$refs.mobileInput.value
        ? this.$refs.mobileInput.value
        : '';
      const mobile = String(this.mobile || inputValue || '').replace(/[^0-9]/g, '').trim();
      this.mobile = mobile;
      return mobile;
    },
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    goBuyESim() {
      window.location.href = 'https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim';
    },
    goLogin() {
      let that = this
      const mobile = this.getNormalizedMobile();
      if(!mobile){
        that.$utils.alertText(that.$t('loginTips'),80)
      }else{
        this.checkMobile();
      }
    },
    checkMobile() {
      let that = this
      let mobile = this.getNormalizedMobile()
      if (!mobile) {
        that.$utils.alertText(that.$t('loginTips'),80)
        return;
      }
      let data = {
        'mobile': mobile,
        'channel': that.channel,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/check_user', data, r => {
        that.$parent.loadModal(false);
        sessionStorage.setItem('login_mobile', that.mobile);
        if(r.code==1){
          that.$router.push({path: 'otp' })
        }else if(r.code == -1){
          that.$router.push({path: '/sub', query: {mobile: mobile,channel: that.channel}});
        } else{
          that.$utils.alertText(r.msg,100,2000);
        }
      })
    },
    sendReport(){
      let that = this
      let data = {
        'channel': that.channel,
        'type': "login",
      }
      that.$api.post('/api/land/config', data, r => {

      })
    },
    //加密
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm"); // 16字节密钥
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);

      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    //解密
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          {ciphertext: encrypted},
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
      } catch (e) {

        return "";
      }
    },
  }
}
</script>
<style scoped>
.otp-b {
  justify-content: space-evenly;
}

.login-overlay {
  position: relative;
  z-index: 10;
}

.login-list {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.login-list .drown-li {
  width: min(260px, 40vw);
}

.login-list .disflex {
  aspect-ratio: 318 / 132;
  justify-content: center;
  width: 100%;
  background-size: 100% 100% !important;
}

.middle img {
  top: clamp(118px, 28vw, 210px) !important;
  width: min(460px, 72vw) !important;
}

.login-tip,
.login-footer {
  position: relative;
  z-index: 3;
}


.input-div .input-item {
  width: 86% !important;
  height: clamp(48px, 10.1vw, 76px) !important;
  border-radius: 60px !important;
  margin: 0 auto !important;
}

.input-div .input-item2 {
  height: clamp(48px, 10.1vw, 76px) !important;
  border-radius: 60px !important;
}

.input-div input.input {
  height: clamp(48px, 10.1vw, 76px) !important;
  line-height: clamp(48px, 10.1vw, 76px) !important;
  font-size: clamp(24px, 5.6vw, 42px) !important;
  font-weight: 700 !important;
  padding: 0 clamp(14px, 3.2vw, 24px) !important;
  margin: 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
  box-sizing: border-box !important;
}

.login-footer {
  margin-top: clamp(20px, 5vw, 40px) !important;
}

.day-en {
  background: url(../../static/images/daily-bg_en.png) no-repeat center !important;
  background-size: 100% 100% !important;
}

.esim-row {
  margin-top: clamp(10px, 2.2vw, 16px);
  z-index: 10;
  position: relative;
}

.esim-text {
  align-items: center;
  background: rgba(4, 35, 111, 0.84);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  box-shadow: 0 2px 5px rgba(0, 23, 82, 0.45);
  color: #fff;
  display: inline-flex;
  font-size: clamp(13px, 2.9vw, 22px);
  gap: 0.15em;
  line-height: 1.5;
  max-width: calc(100% - 24px);
  min-height: clamp(32px, 7.5vw, 52px);
  text-align: center;
  padding: clamp(4px, 1vw, 8px) clamp(12px, 2.7vw, 20px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);
  font-weight: 600;
}

.esim-link {
  color: #ffd95a;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 600;
}

</style>



// WEBPACK FOOTER //
// src/page/Login.vue